
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12484',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12484",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.477",
  "data-fetching-client": "static-1.9730",
  "foundations-components": "static-1.8062",
  "foundations-components-legacy": "static-1.1087",
  "foundations-theming": "static-1.4493",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8084",
  "hub-http-shared-msw-handlers": "static-1.10126",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11541",
  "I18n": "static-7.1633",
  "jasmine-runner": "static-1.6530",
  "marketplace-storefront-base": "static-1.12546",
  "quartz": "static-1.7111",
  "react-dlb": "static-1.80",
  "react-rhumb": "static-1.16747",
  "reactive-variable-buffer-atom": "static-1.2925",
  "reporting-testing-lib": "static-1.9772",
  "settings-ui-lib": "static-1.12587",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7264",
  "ui-addon-i18n": "static-1.11218",
  "ui-addon-react-router-dom": "static-1.9608",
  "unified-auth": "static-1.572",
  "unified-auth-core-lib": "static-1.854",
  "usage-tracker": "static-1.7416",
  "usage-tracker-core": "static-1.7266",
  "customer-data-property-utils": "static-1.8161",
  "hub-http": "static-1.6289",
  "integrations-lib": "static-1.16387",
  "marketplace-ui-common": "static-1.20012",
  "property-management-iframe": "static-1.13397",
  "quartz-config": "static-1.889",
  "quartz-core": "static-1.6330",
  "quartz-routing": "static-1.541",
  "quick-fetch": "static-1.3969",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4721",
  "ts-schema": "static-1.4131",
  "ui-universal-auth": "static-1.9058",
  "UIComponents": "static-3.8487",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3451",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3388",
  "quartz-webpack": "static-1.3335",
  "bend-plugin-quartz-routing": "static-1.189",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4331",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4937",
  "foundations-theming-specialty": "static-1.2209",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9489",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5395",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.488",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2104",
  "ui-fonts": "static-1.803",
  "ui-images": "static-2.1169",
  "bend-plugin-foundations-theming": "static-1.2976",
  "foundations-theming-base": "static-1.3478",
  "stylex": "static-1.34",
  "HeadJS": "static-2.765",
  "hs-test-utils-bend-plugin": "static-1.3195",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4393",
  "ai-components-ui-library": "static-1.9135",
  "ai-rendering-library": "static-1.10415",
  "chirp-fetch": "static-1.1954",
  "connections-embed-lib": "static-1.1120",
  "copilot-toolkit": "static-1.11315",
  "feedback-loader": "static-1.29419",
  "laboratory-lib": "static-3.7222",
  "marketplace-embed": "static-1.22298",
  "marketplace-ui-details": "static-1.9907",
  "marketplace-ui-reviews": "static-1.19967",
  "marketplace-ui-tracking": "static-1.14182",
  "sanitize-text": "static-1.8211",
  "ui-addon-video-player": "static-1.8771",
  "usage-tracker-multi": "static-1.5830",
  "usage-tracker-session-replay": "static-1.5102",
  "wootric-nps": "static-1.7033",
  "quartz-head": "static-1.776",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4719",
  "immer": "static-1.33",
  "immerable": "static-1.4221",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2535",
  "reporting-data": "static-1.67839",
  "cssUtils": "static-1.809",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11848",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10276",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10431",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7406",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18544",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4580",
  "foundations-components-test-utils": "static-1.5545",
  "quartz-i18n": "static-1.786",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.132",
  "google-sheets-integration-lib": "static-1.438",
  "microsoft-drive-integration-lib": "static-1.578",
  "slack-ui-library": "static-1.10459",
  "fsm": "static-1.3796",
  "customer-data-objects": "static-1.7745",
  "property-translator": "static-1.5463",
  "hs-locale-management": "static-1.132",
  "frontend-preferences-client": "static-1.7993",
  "hs-promise-utils": "static-1.5658",
  "hubspot-apollo-client": "static-1.4945",
  "integrations-error-boundary-lib": "static-1.13802",
  "integrations-tracking-lib": "static-1.5673",
  "native-integrations-shared-strings": "static-1.7849",
  "reselect": "static-2.16",
  "sanitize": "static-1.4544",
  "superstore": "static-1.4827",
  "ui-shepherd-react": "static-3.10286",
  "ai-settings-ui-library": "static-1.7991",
  "hub-http-janus": "static-1.840",
  "hubspotter-http": "static-1.4702",
  "immutable-less": "static-1.4720",
  "marketplace-ui-client-types": "static-1.17419",
  "nav-meta": "static-1.29841",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10316",
  "ui-addon-upgrades": "static-9.18090",
  "inbound-db-properties-service-client": "static-1.3895",
  "property-management-common": "static-1.5685",
  "ui-addon-iframeable": "static-1.9129",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.786",
  "quartz-test": "static-1.786",
  "quartz-tracking": "static-1.490",
  "trellis-components": "static-1.2123",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.131",
  "bender-build-tools": "static-1.3260",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21618",
  "ContentUtils": "static-1.68564",
  "customer-data-objects-ui-components": "static-1.13099",
  "sassPrefix": "static-1.157",
  "breeze-engine-core": "static-1.188",
  "breeze-onboarding-components": "static-1.147",
  "avatar-components": "static-1.2564",
  "customer-data-filters-ui": "static-1.40033",
  "customer-data-reference-ui-components": "static-1.13237",
  "embedded-academy-lib": "static-1.14554",
  "ExportDialog": "static-6.10451",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41483",
  "reporting-snowflake": "static-1.56457",
  "reporting-ui-components": "static-2.65110",
  "reporting-visualizations": "static-1.59915",
  "ui-addon-teams": "static-1.21644",
  "integrations-reconnect-lib": "static-1.93",
  "magpie-lib": "static-1.5598",
  "navigation-components": "static-1.18204",
  "breeze-engine-lib": "static-1.910",
  "magpie-types": "static-1.5058",
  "simple-logging-lib": "static-1.3117",
  "ai-studio-lib": "static-1.11814",
  "app-governance-lib": "static-1.1768",
  "developer-experience-shared-components": "static-1.10580",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8070",
  "ui-product-approvals": "static-1.28357",
  "ui-tool-access": "static-1.10215",
  "usage-based-billing-components-lib": "static-1.9274",
  "usage-tracker-anonymous": "static-1.5833",
  "usage-tracker-public": "static-1.7227",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3637",
  "persist-promise": "static-1.3766",
  "reference-resolvers": "static-1.8239",
  "ui-extensibility-client-types": "static-1.3993",
  "hubspot-apollo-cache": "static-1.404",
  "universal-page-editor-lib": "static-1.3085",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2974",
  "merchandise-lib": "static-1.265",
  "atom": "static-1.5142",
  "purchase-motions-components": "static-1.6032",
  "salesImages": "static-1.526",
  "batch-promise": "static-1.1609",
  "crm-component-utils": "static-1.39263",
  "crm-properties-common-lib": "static-1.5956",
  "customer-data-properties": "static-1.51827",
  "framework-data-schema-resolvers": "static-1.6957",
  "property-value-citations": "static-1.2441",
  "reference-resolvers-lite": "static-1.8165",
  "ui-business-units-lib": "static-1.9126",
  "navigation-messaging": "static-1.7531",
  "hubspotter-http-shared-msw-handlers": "static-1.10124",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1004",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4880",
  "content-icons-ui": "static-1.2244",
  "customer-data-ui-utilities": "static-1.9892",
  "conversations-skeleton-state": "static-1.7316",
  "crm-message-bus": "static-1.43154",
  "customer-data-filters-ui-msw-helpers": "static-1.22468",
  "events-data-lib": "static-1.297",
  "FormUrlGenerator": "static-2.4788",
  "framework-builder-read-service-client": "static-1.4056",
  "framework-data-schema-quick-fetch": "static-1.6862",
  "multi-account-reference-resolvers": "static-1.1050",
  "onboarding-tours": "static-1.16729",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13877",
  "academy-common-lib": "static-1.14014",
  "content-assistance-lib": "static-1.7856",
  "dashboard-lib": "static-1.81814",
  "file-manager-components": "static-1.23800",
  "getting-started-shared-tasks": "static-1.18604",
  "hubspot-prosemirror": "static-1.18420",
  "hubspot-prosemirror-plugins": "static-1.18412",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19942",
  "share-with-third-party-component-lib": "static-1.8772",
  "ui-addon-draggable": "static-3.4829",
  "ui-asset-management-lib": "static-1.11125",
  "user-context": "static-1.5175",
  "growth-payments-core": "static-1.25577",
  "reporting-plugins": "static-1.10428",
  "reporting-reports": "static-1.67517",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.792",
  "nest": "static-1.299",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10695",
  "framework-listing-lib": "static-2.28883",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30883",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4318",
  "ui-product-approvals-common": "static-1.252",
  "onboarding-scopes": "static-1.6529",
  "onboarding-tours-client": "static-1.4943",
  "platform-infra-nav-components": "static-1.7724",
  "subscription-experience-data-types": "static-1.15019",
  "crm-record-cards-service-types": "static-1.3641",
  "location-customization-utils-lib": "static-1.9461",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6035",
  "signup-constants": "static-1.19001",
  "signup-ui-url-generator": "static-2.8123",
  "card-properties-lib": "static-1.44400",
  "commerce-subscription-lib": "static-1.37320",
  "crm-actions": "static-1.6406",
  "crm-cards-sdk": "static-1.43788",
  "customer-data-properties-shared-msw-handlers": "static-1.9453",
  "customer-data-tracking": "static-1.6957",
  "hs-resources": "static-1.237",
  "pulse": "static-1.659",
  "calling-global-api": "static-1.64756",
  "calling-internal-common": "static-1.31372",
  "calling-lifecycle-internal": "static-1.66138",
  "calling-lifecycle-messages": "static-1.58432",
  "commerce-products-lib": "static-1.9801",
  "conditional-properties-service-client": "static-1.3848",
  "crm-links": "static-1.6374",
  "crm-pipelines-api-client-types": "static-1.4190",
  "external-options-client-types": "static-1.4199",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4273",
  "meetings-icalendar-utils-lib": "static-1.700",
  "multi-currency-client-types": "static-1.3743",
  "object-builder-ui-client": "static-1.48989",
  "pipeline-validation-client-types": "static-1.4017",
  "smart-property-lib": "static-1.7499",
  "tiered-pricing": "static-1.1373",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11056",
  "fdsr-migration-layer": "static-1.76",
  "react-dnd-compat": "static-1.4681",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1061",
  "growth-data-modal": "static-1.5534",
  "growth-onboarding-confetti": "static-1.3134",
  "growth-onboarding-next-action-utils": "static-1.2121",
  "onboarding-tours-utils": "static-1.795",
  "ui-shepherd-tracker": "static-1.7667",
  "academy-service-client": "static-1.3751",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39299",
  "FileManagerLib": "static-1.39440",
  "video-embed": "static-1.36003",
  "ui-coaching-tips": "static-1.28753",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11511",
  "video-data-lib": "static-1.35169",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8532",
  "payment-link-components": "static-1.23696",
  "ui-addon-emoji-picker": "static-1.9954",
  "EmailSignatureEditor": "static-1.24526",
  "viral-links-lib": "static-1.7137",
  "data-token-picker": "static-1.16523",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.294",
  "timezone-utils": "static-2.5311",
  "seat-types-lib": "static-1.177",
  "getting-started-shared-tasks-store": "static-1.17722",
  "ui-addon-opt": "static-4.8428",
  "campaign-roi-lib": "static-1.9299",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25594",
  "framework-data-table": "static-2.12073",
  "marketing-platform-lib": "static-1.6930",
  "nudge-client-utils": "static-1.2728",
  "nudge-custom-ui-functions": "static-1.1152",
  "switchboard-lib": "static-1.289",
  "app-users-service-client": "static-1.5674",
  "app-users-service-types": "static-1.5082",
  "mini-checkout-client": "static-1.26965",
  "onboarding-utils": "static-1.5425",
  "permissions-shared-i18n-strings-fe": "static-1.2058",
  "ui-coaching-tips-shared-config": "static-1.28738",
  "edison-service-client-types": "static-1.457",
  "crm_data": "static-4.92191",
  "customer-data-sidebar": "static-2.46206",
  "enrichment-properties-lib": "static-1.16617",
  "ui-addon-draggable-compat": "static-2.4326",
  "commerce-billing-lib": "static-1.19312",
  "commerce-shared-components-lib": "static-1.18692",
  "commerce-tools-ui-lib": "static-1.10561",
  "crm-fe-perf": "static-1.22970",
  "event-emitter": "static-1.1016",
  "bend-plugin-pulse": "static-1.162",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31379",
  "shared-worker-versioning": "static-1.11103",
  "calling-usage-tracker": "static-1.6609",
  "voice-sms-access-library": "static-1.1267",
  "commerce-permissions": "static-1.842",
  "products-iframe-lib": "static-1.8124",
  "products-ui-components-shared-msw-handlers": "static-1.10508",
  "data-agent-kit": "static-1.300",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10209",
  "policy-lib": "static-1.6846",
  "react-tinymce": "static-1.55432",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10272",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54558",
  "tinymce-plugins": "static-1.57672",
  "tinymce-themes": "static-1.56528",
  "onboarding-data-sync-lib": "static-1.2078",
  "growth-onboarding-next-action-components": "static-1.2149",
  "user-context-client": "static-1.4658",
  "audio-components": "static-1.6015",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36951",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4604",
  "video-components": "static-1.13513",
  "outpost": "static-1.4240",
  "growth-onboarding-feedback-components": "static-1.6646",
  "content-media-composition-data-lib": "static-1.12558",
  "content-media-compositions": "static-2.16565",
  "media-bridge-lib": "static-1.19041",
  "commerce-tours-lib": "static-1.6228",
  "growth-onboarding-reliability": "static-1.5148",
  "sales-checkout-service-client": "static-1.3689",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21791",
  "sales-email-signature-service-client": "static-1.3915",
  "ts-utils-lib": "static-1.239",
  "crm-export-dialog": "static-1.6356",
  "crm-index-associations-lib": "static-1.6510",
  "crm-view-components": "static-1.484",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7396",
  "nudge-custom-function-registry": "static-1.2485",
  "nudge-renderer-utils": "static-1.2804",
  "whisper-core-api": "static-1.6817",
  "InboxConnectUtils": "static-4.14998",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5695",
  "settings-content-modals": "static-1.46281",
  "crm_universal": "static-1.22123",
  "customer-data-email": "static-1.18150",
  "card-payment-highlight-lib": "static-1.37368",
  "card-subscription-highlight-lib": "static-1.39743",
  "commerce-contract-lib": "static-1.12378",
  "invoices-highlight-card-lib": "static-1.54929",
  "orders-highlight-card-lib": "static-1.21658",
  "products-highlight-card-lib": "static-1.18084",
  "quotes-highlight-card-lib": "static-1.72257",
  "crm-source-interpretation-lib": "static-1.5412",
  "utility-belt": "static-1.2601",
  "payments-enrollment-embed-lib": "static-1.23089",
  "stripe-embedded-components": "static-1.7624",
  "customer-data-rte": "static-1.33180",
  "cv-backend-services": "static-1.1555",
  "growth-onboarding-empty-states": "static-1.5862",
  "payments-post-enroll-local-storage-lib": "static-1.5176",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38347",
  "trials-service-types": "static-1.3957",
  "calling-orchestration-schema": "static-1.36044",
  "sales-views-client-types": "static-1.4325",
  "hub-http-contrib": "static-1.3108",
  "interframe": "static-3.4827",
  "tinymce-data": "static-1.40643",
  "ui-addon-sales-email": "static-1.5278",
  "layout-dnd-components": "static-1.12574",
  "layout-dnd-utils": "static-1.11549",
  "ui-brand-identity-lib": "static-1.15533",
  "NamespacedHubStyle": "static-2.9109",
  "meetings-connect-utils-lib": "static-1.7671",
  "social-insights-client-types": "static-1.22269",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4226",
  "checkout-sdk": "static-3.23808",
  "checkout-service-types": "static-1.3852",
  "company-details-components": "static-1.6264",
  "payment-method-components": "static-1.6959",
  "pricing-pages-ui-components": "static-1.14382",
  "quote-checkout-service-types": "static-1.3533",
  "upgrade-catalog-service-types": "static-1.3588",
  "access-control-lib": "static-1.10502",
  "EmailComponents": "static-1.54952",
  "EmailData": "static-1.53629",
  "redux-less": "static-2.9551",
  "sequences-lib": "static-1.8159",
  "ui-gdpr-components": "static-1.10417",
  "products-ui-components": "static-1.40319",
  "accounting-integrations-ui-components": "static-1.7170",
  "invoices-ui-lib": "static-1.54945",
  "commerce-products-api": "static-1.2396",
  "invoices-iframe-lib": "static-1.57003",
  "quotes-modal-lib": "static-1.102935",
  "quotes-ui-lib": "static-1.80978",
  "stripe-connect-js": "static-1.70",
  "draft-content-plugins": "static-1.28453",
  "ContentData": "static-1.68639",
  "layout-data-lib": "static-1.9874",
  "hub-http-rxjs": "static-1.806",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4006",
  "billing-payments-client-types": "static-1.4059",
  "react-performance-metrics-lib": "static-1.623",
  "account-and-billing-fintech-outages": "static-3.18673",
  "pricing-pages-api": "static-1.14247",
  "ContentComponents": "static-2.71520",
  "marketing-contacts-lib": "static-1.10289",
  "marketing-email-service-types": "static-1.1947",
  "messaging-editing-lib": "static-1.46468",
  "messaging-usage-based-billing-components-lib": "static-1.1330",
  "automation-ui-source-apps": "static-1.19080",
  "automation-ui-types": "static-1.19998",
  "messaging-types-lib": "static-1.46205",
  "onboarding-settings-client": "static-1.4572",
  "sequences-client-types-lib": "static-1.8016",
  "commerce-tax-lib": "static-1.601",
  "price-books-api": "static-1.1102",
  "price-books-components": "static-1.1160",
  "property-description-translator": "static-1.3907",
  "ramp-editor": "static-1.307",
  "commerce-analytics-service-client": "static-1.3677",
  "totals-ui-components": "static-1.23796",
  "SalesContentIndexUI": "static-3.9347",
  "advanced-menus-core": "static-1.15235",
  "advanced-menus-lib": "static-1.12164",
  "ui-memberships-settings-lib": "static-1.34233",
  "segments-query-core": "static-1.1485",
  "eligibility-engine-service-types": "static-1.3238",
  "automation-ui-ubb": "static-1.5914",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7405",
  "data-token-views": "static-1.16504",
  "forms-utils-lib": "static-1.12710",
  "payments-embed-points-lib": "static-1.13174",
  "simple-menus-core": "static-1.15234",
  "simple-menus-lib": "static-1.16751",
  "videoconference-integration-components": "static-1.6919",
  "marketing-contacts-client": "static-1.7582",
  "automation-applications-service-types": "static-1.3570",
  "automation-platform-service-types": "static-1.2610",
  "ContentEditorUI": "static-2.77294",
  "short-messages-app-service-client": "static-1.4029",
  "web-interactives-components": "static-1.13875",
  "web-interactives-data": "static-1.13876",
  "messaging-shared-utils-lib": "static-1.779",
  "messaging-user-info-utils-lib": "static-1.949",
  "email-portal-health-service-types": "static-1.1046",
  "line-items-api": "static-1.797",
  "commerce-totals-service-types": "static-1.3870",
  "FireAlarmUi": "static-1.4563",
  "sales-templates-service-types-lib": "static-1.4221",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21934",
  "automation-ui-usage-tracking": "static-1.21397",
  "data-studio-ubb": "static-1.2921",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27186",
  "collaboration-sidebar": "static-1.58022",
  "content-management-data-lib": "static-1.5490",
  "copilot-plugins": "static-1.11288",
  "cta-picker": "static-1.36592",
  "customer-agent-discovery-components-lib": "static-1.3279",
  "editor-components": "static-1.13328",
  "editor-iframe-lib": "static-1.8498",
  "error-messaging-js": "static-1.5260",
  "FormsCommonComponents": "static-1.86042",
  "pictos": "static-7.185",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10713",
  "SharedLegalStrings": "static-1.1813",
  "smart-content-core": "static-1.42634",
  "smart-content-lib": "static-1.43287",
  "social-composer-lib": "static-1.59416",
  "structured-content-lib": "static-1.25380",
  "theme-previewer-lib": "static-1.53427",
  "tinymce-copilot": "static-1.16626",
  "xray-recommendation-lib": "static-1.8000",
  "automation-ui-routing": "static-1.21355",
  "sql-reporting-client-types": "static-1.5690",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42342",
  "campaigns-utils-lib": "static-1.3255",
  "reporting-enablement": "static-1.23162",
  "chatspot-widget-iframe": "static-1.21609",
  "collaboration-sidebar-common": "static-1.2819",
  "forms-ai-lib": "static-1.4421",
  "codemirror-dlb": "static-1.58853",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6500",
  "report-customization-components": "static-1.13348",
  "data-quality-ui-library": "static-1.13222",
  "reporting-filters": "static-1.499",
  "reporting-insights-lib": "static-1.1945"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12484",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.477",
  "data-fetching-client": "/data-fetching-client/static-1.9730",
  "foundations-components": "/foundations-components/static-1.8062",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1087",
  "foundations-theming": "/foundations-theming/static-1.4493",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8084",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10126",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11541",
  "I18n": "/I18n/static-7.1633",
  "jasmine-runner": "/jasmine-runner/static-1.6530",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12546",
  "quartz": "/quartz/static-1.7111",
  "react-dlb": "/react-dlb/static-1.80",
  "react-rhumb": "/react-rhumb/static-1.16747",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2925",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9772",
  "settings-ui-lib": "/settings-ui-lib/static-1.12587",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7264",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11218",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9608",
  "unified-auth": "/unified-auth/static-1.572",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.854",
  "usage-tracker": "/usage-tracker/static-1.7416",
  "usage-tracker-core": "/usage-tracker-core/static-1.7266",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8161",
  "hub-http": "/hub-http/static-1.6289",
  "integrations-lib": "/integrations-lib/static-1.16387",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20012",
  "property-management-iframe": "/property-management-iframe/static-1.13397",
  "quartz-config": "/quartz-config/static-1.889",
  "quartz-core": "/quartz-core/static-1.6330",
  "quartz-routing": "/quartz-routing/static-1.541",
  "quick-fetch": "/quick-fetch/static-1.3969",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4721",
  "ts-schema": "/ts-schema/static-1.4131",
  "ui-universal-auth": "/ui-universal-auth/static-1.9058",
  "UIComponents": "/UIComponents/static-3.8487",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3451",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3388",
  "quartz-webpack": "/quartz-webpack/static-1.3335",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.189",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4331",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4937",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2209",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9489",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5395",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2104",
  "ui-fonts": "/ui-fonts/static-1.803",
  "ui-images": "/ui-images/static-2.1169",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2976",
  "foundations-theming-base": "/foundations-theming-base/static-1.3478",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.765",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3195",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4393",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9135",
  "ai-rendering-library": "/ai-rendering-library/static-1.10415",
  "chirp-fetch": "/chirp-fetch/static-1.1954",
  "connections-embed-lib": "/connections-embed-lib/static-1.1120",
  "copilot-toolkit": "/copilot-toolkit/static-1.11315",
  "feedback-loader": "/feedback-loader/static-1.29419",
  "laboratory-lib": "/laboratory-lib/static-3.7222",
  "marketplace-embed": "/marketplace-embed/static-1.22298",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9907",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19967",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14182",
  "sanitize-text": "/sanitize-text/static-1.8211",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8771",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5830",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5102",
  "wootric-nps": "/wootric-nps/static-1.7033",
  "quartz-head": "/quartz-head/static-1.776",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4719",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4221",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2535",
  "reporting-data": "/reporting-data/static-1.67839",
  "cssUtils": "/cssUtils/static-1.809",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11848",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10276",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10431",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7406",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18544",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4580",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5545",
  "quartz-i18n": "/quartz-i18n/static-1.786",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.132",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.438",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.578",
  "slack-ui-library": "/slack-ui-library/static-1.10459",
  "fsm": "/fsm/static-1.3796",
  "customer-data-objects": "/customer-data-objects/static-1.7745",
  "property-translator": "/property-translator/static-1.5463",
  "hs-locale-management": "/hs-locale-management/static-1.132",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7993",
  "hs-promise-utils": "/hs-promise-utils/static-1.5658",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4945",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13802",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5673",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7849",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4544",
  "superstore": "/superstore/static-1.4827",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10286",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7991",
  "hub-http-janus": "/hub-http-janus/static-1.840",
  "hubspotter-http": "/hubspotter-http/static-1.4702",
  "immutable-less": "/immutable-less/static-1.4720",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17419",
  "nav-meta": "/nav-meta/static-1.29841",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10316",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18090",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3895",
  "property-management-common": "/property-management-common/static-1.5685",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9129",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.786",
  "quartz-test": "/quartz-test/static-1.786",
  "quartz-tracking": "/quartz-tracking/static-1.490",
  "trellis-components": "/trellis-components/static-1.2123",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.131",
  "bender-build-tools": "/bender-build-tools/static-1.3260",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21618",
  "ContentUtils": "/ContentUtils/static-1.68564",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13099",
  "sassPrefix": "/sassPrefix/static-1.157",
  "breeze-engine-core": "/breeze-engine-core/static-1.188",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.147",
  "avatar-components": "/avatar-components/static-1.2564",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40033",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13237",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14554",
  "ExportDialog": "/ExportDialog/static-6.10451",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41483",
  "reporting-snowflake": "/reporting-snowflake/static-1.56457",
  "reporting-ui-components": "/reporting-ui-components/static-2.65110",
  "reporting-visualizations": "/reporting-visualizations/static-1.59915",
  "ui-addon-teams": "/ui-addon-teams/static-1.21644",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.93",
  "magpie-lib": "/magpie-lib/static-1.5598",
  "navigation-components": "/navigation-components/static-1.18204",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.910",
  "magpie-types": "/magpie-types/static-1.5058",
  "simple-logging-lib": "/simple-logging-lib/static-1.3117",
  "ai-studio-lib": "/ai-studio-lib/static-1.11814",
  "app-governance-lib": "/app-governance-lib/static-1.1768",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10580",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8070",
  "ui-product-approvals": "/ui-product-approvals/static-1.28357",
  "ui-tool-access": "/ui-tool-access/static-1.10215",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9274",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5833",
  "usage-tracker-public": "/usage-tracker-public/static-1.7227",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3637",
  "persist-promise": "/persist-promise/static-1.3766",
  "reference-resolvers": "/reference-resolvers/static-1.8239",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3993",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.404",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3085",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2974",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "atom": "/atom/static-1.5142",
  "purchase-motions-components": "/purchase-motions-components/static-1.6032",
  "salesImages": "/salesImages/static-1.526",
  "batch-promise": "/batch-promise/static-1.1609",
  "crm-component-utils": "/crm-component-utils/static-1.39263",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5956",
  "customer-data-properties": "/customer-data-properties/static-1.51827",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6957",
  "property-value-citations": "/property-value-citations/static-1.2441",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8165",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9126",
  "navigation-messaging": "/navigation-messaging/static-1.7531",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10124",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1004",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4880",
  "content-icons-ui": "/content-icons-ui/static-1.2244",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9892",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7316",
  "crm-message-bus": "/crm-message-bus/static-1.43154",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22468",
  "events-data-lib": "/events-data-lib/static-1.297",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4788",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4056",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6862",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1050",
  "onboarding-tours": "/onboarding-tours/static-1.16729",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13877",
  "academy-common-lib": "/academy-common-lib/static-1.14014",
  "content-assistance-lib": "/content-assistance-lib/static-1.7856",
  "dashboard-lib": "/dashboard-lib/static-1.81814",
  "file-manager-components": "/file-manager-components/static-1.23800",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18604",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18420",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18412",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19942",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8772",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4829",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11125",
  "user-context": "/user-context/static-1.5175",
  "growth-payments-core": "/growth-payments-core/static-1.25577",
  "reporting-plugins": "/reporting-plugins/static-1.10428",
  "reporting-reports": "/reporting-reports/static-1.67517",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.792",
  "nest": "/nest/static-1.299",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10695",
  "framework-listing-lib": "/framework-listing-lib/static-2.28883",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30883",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4318",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.252",
  "onboarding-scopes": "/onboarding-scopes/static-1.6529",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4943",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7724",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15019",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3641",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9461",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6035",
  "signup-constants": "/signup-constants/static-1.19001",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8123",
  "card-properties-lib": "/card-properties-lib/static-1.44400",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37320",
  "crm-actions": "/crm-actions/static-1.6406",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43788",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9453",
  "customer-data-tracking": "/customer-data-tracking/static-1.6957",
  "hs-resources": "/hs-resources/static-1.237",
  "pulse": "/pulse/static-1.659",
  "calling-global-api": "/calling-global-api/static-1.64756",
  "calling-internal-common": "/calling-internal-common/static-1.31372",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66138",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58432",
  "commerce-products-lib": "/commerce-products-lib/static-1.9801",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3848",
  "crm-links": "/crm-links/static-1.6374",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4190",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4273",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.700",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3743",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48989",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4017",
  "smart-property-lib": "/smart-property-lib/static-1.7499",
  "tiered-pricing": "/tiered-pricing/static-1.1373",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11056",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.76",
  "react-dnd-compat": "/react-dnd-compat/static-1.4681",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1061",
  "growth-data-modal": "/growth-data-modal/static-1.5534",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3134",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2121",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.795",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7667",
  "academy-service-client": "/academy-service-client/static-1.3751",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39299",
  "FileManagerLib": "/FileManagerLib/static-1.39440",
  "video-embed": "/video-embed/static-1.36003",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28753",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11511",
  "video-data-lib": "/video-data-lib/static-1.35169",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8532",
  "payment-link-components": "/payment-link-components/static-1.23696",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9954",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24526",
  "viral-links-lib": "/viral-links-lib/static-1.7137",
  "data-token-picker": "/data-token-picker/static-1.16523",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.294",
  "timezone-utils": "/timezone-utils/static-2.5311",
  "seat-types-lib": "/seat-types-lib/static-1.177",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17722",
  "ui-addon-opt": "/ui-addon-opt/static-4.8428",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9299",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25594",
  "framework-data-table": "/framework-data-table/static-2.12073",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6930",
  "nudge-client-utils": "/nudge-client-utils/static-1.2728",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1152",
  "switchboard-lib": "/switchboard-lib/static-1.289",
  "app-users-service-client": "/app-users-service-client/static-1.5674",
  "app-users-service-types": "/app-users-service-types/static-1.5082",
  "mini-checkout-client": "/mini-checkout-client/static-1.26965",
  "onboarding-utils": "/onboarding-utils/static-1.5425",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2058",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28738",
  "edison-service-client-types": "/edison-service-client-types/static-1.457",
  "crm_data": "/crm_data/static-4.92191",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46206",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16617",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4326",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19312",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18692",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10561",
  "crm-fe-perf": "/crm-fe-perf/static-1.22970",
  "event-emitter": "/event-emitter/static-1.1016",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.162",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31379",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11103",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6609",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1267",
  "commerce-permissions": "/commerce-permissions/static-1.842",
  "products-iframe-lib": "/products-iframe-lib/static-1.8124",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10508",
  "data-agent-kit": "/data-agent-kit/static-1.300",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10209",
  "policy-lib": "/policy-lib/static-1.6846",
  "react-tinymce": "/react-tinymce/static-1.55432",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10272",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54558",
  "tinymce-plugins": "/tinymce-plugins/static-1.57672",
  "tinymce-themes": "/tinymce-themes/static-1.56528",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2078",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2149",
  "user-context-client": "/user-context-client/static-1.4658",
  "audio-components": "/audio-components/static-1.6015",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36951",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4604",
  "video-components": "/video-components/static-1.13513",
  "outpost": "/outpost/static-1.4240",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6646",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12558",
  "content-media-compositions": "/content-media-compositions/static-2.16565",
  "media-bridge-lib": "/media-bridge-lib/static-1.19041",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6228",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5148",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21791",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3915",
  "ts-utils-lib": "/ts-utils-lib/static-1.239",
  "crm-export-dialog": "/crm-export-dialog/static-1.6356",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6510",
  "crm-view-components": "/crm-view-components/static-1.484",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7396",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2485",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2804",
  "whisper-core-api": "/whisper-core-api/static-1.6817",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14998",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5695",
  "settings-content-modals": "/settings-content-modals/static-1.46281",
  "crm_universal": "/crm_universal/static-1.22123",
  "customer-data-email": "/customer-data-email/static-1.18150",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37368",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39743",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12378",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54929",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21658",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18084",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72257",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5412",
  "utility-belt": "/utility-belt/static-1.2601",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23089",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7624",
  "customer-data-rte": "/customer-data-rte/static-1.33180",
  "cv-backend-services": "/cv-backend-services/static-1.1555",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5862",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5176",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38347",
  "trials-service-types": "/trials-service-types/static-1.3957",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36044",
  "sales-views-client-types": "/sales-views-client-types/static-1.4325",
  "hub-http-contrib": "/hub-http-contrib/static-1.3108",
  "interframe": "/interframe/static-3.4827",
  "tinymce-data": "/tinymce-data/static-1.40643",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5278",
  "layout-dnd-components": "/layout-dnd-components/static-1.12574",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11549",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15533",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9109",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7671",
  "social-insights-client-types": "/social-insights-client-types/static-1.22269",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4226",
  "checkout-sdk": "/checkout-sdk/static-3.23808",
  "checkout-service-types": "/checkout-service-types/static-1.3852",
  "company-details-components": "/company-details-components/static-1.6264",
  "payment-method-components": "/payment-method-components/static-1.6959",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14382",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3533",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3588",
  "access-control-lib": "/access-control-lib/static-1.10502",
  "EmailComponents": "/EmailComponents/static-1.54952",
  "EmailData": "/EmailData/static-1.53629",
  "redux-less": "/redux-less/static-2.9551",
  "sequences-lib": "/sequences-lib/static-1.8159",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10417",
  "products-ui-components": "/products-ui-components/static-1.40319",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7170",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54945",
  "commerce-products-api": "/commerce-products-api/static-1.2396",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57003",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102935",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80978",
  "stripe-connect-js": "/stripe-connect-js/static-1.70",
  "draft-content-plugins": "/draft-content-plugins/static-1.28453",
  "ContentData": "/ContentData/static-1.68639",
  "layout-data-lib": "/layout-data-lib/static-1.9874",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.806",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4006",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4059",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.623",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18673",
  "pricing-pages-api": "/pricing-pages-api/static-1.14247",
  "ContentComponents": "/ContentComponents/static-2.71520",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10289",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1947",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46468",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1330",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19080",
  "automation-ui-types": "/automation-ui-types/static-1.19998",
  "messaging-types-lib": "/messaging-types-lib/static-1.46205",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4572",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8016",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.601",
  "price-books-api": "/price-books-api/static-1.1102",
  "price-books-components": "/price-books-components/static-1.1160",
  "property-description-translator": "/property-description-translator/static-1.3907",
  "ramp-editor": "/ramp-editor/static-1.307",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3677",
  "totals-ui-components": "/totals-ui-components/static-1.23796",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9347",
  "advanced-menus-core": "/advanced-menus-core/static-1.15235",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12164",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34233",
  "segments-query-core": "/segments-query-core/static-1.1485",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3238",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5914",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7405",
  "data-token-views": "/data-token-views/static-1.16504",
  "forms-utils-lib": "/forms-utils-lib/static-1.12710",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13174",
  "simple-menus-core": "/simple-menus-core/static-1.15234",
  "simple-menus-lib": "/simple-menus-lib/static-1.16751",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6919",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7582",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3570",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2610",
  "ContentEditorUI": "/ContentEditorUI/static-2.77294",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4029",
  "web-interactives-components": "/web-interactives-components/static-1.13875",
  "web-interactives-data": "/web-interactives-data/static-1.13876",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.779",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.949",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1046",
  "line-items-api": "/line-items-api/static-1.797",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3870",
  "FireAlarmUi": "/FireAlarmUi/static-1.4563",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4221",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21934",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21397",
  "data-studio-ubb": "/data-studio-ubb/static-1.2921",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27186",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58022",
  "content-management-data-lib": "/content-management-data-lib/static-1.5490",
  "copilot-plugins": "/copilot-plugins/static-1.11288",
  "cta-picker": "/cta-picker/static-1.36592",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3279",
  "editor-components": "/editor-components/static-1.13328",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8498",
  "error-messaging-js": "/error-messaging-js/static-1.5260",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86042",
  "pictos": "/pictos/static-7.185",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10713",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1813",
  "smart-content-core": "/smart-content-core/static-1.42634",
  "smart-content-lib": "/smart-content-lib/static-1.43287",
  "social-composer-lib": "/social-composer-lib/static-1.59416",
  "structured-content-lib": "/structured-content-lib/static-1.25380",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53427",
  "tinymce-copilot": "/tinymce-copilot/static-1.16626",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8000",
  "automation-ui-routing": "/automation-ui-routing/static-1.21355",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5690",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42342",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3255",
  "reporting-enablement": "/reporting-enablement/static-1.23162",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21609",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2819",
  "forms-ai-lib": "/forms-ai-lib/static-1.4421",
  "codemirror-dlb": "/codemirror-dlb/static-1.58853",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6500",
  "report-customization-components": "/report-customization-components/static-1.13348",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13222",
  "reporting-filters": "/reporting-filters/static-1.499",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1945"
}
};
